import { Api } from '~/core/trpc'

type Props = {
  conversationId: string
}

export const useMembers = ({ conversationId }: Props) => {
  const participantsQuery = Api.chatParticipant.findMany.useQuery(
    { where: { conversationId } },
    { initialData: [] },
  )

  const organizationMembersIds = participantsQuery?.data?.map(
    participant => participant.organizationMemberId,
  )

  const membersQuery = Api.organizationMember.findMany.useQuery(
    {
      where: { id: { in: organizationMembersIds } },
    },
    { initialData: [] },
  )

  return {
    isReady: membersQuery.isFetched,
    members: membersQuery.data,
  }
}
